export default __webpack_public_path__ + "static/media/ShopMarker.12a7da84.svg";